import { render, staticRenderFns } from "./UsageReviewTopSlot.vue?vue&type=template&id=925a9a8c"
import script from "./UsageReviewTopSlot.vue?vue&type=script&lang=js"
export * from "./UsageReviewTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports